<h1 mat-dialog-title>{{ 'platformNotes.dialog.propertyNotes.title' | translate }}</h1>
<mat-dialog-content id="dataToPrint">
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>
  <ng-container *ngIf="propertyIdBalances === '' && companyIdBalances === ''">
    <div *ngIf="sortedDataCompany.length > 0">
      <strong>{{ 'platformNotes.dialog.propertyNotes.company' | translate }}</strong>
      <table class="table table-borderless table-striped" matSort (matSortChange)="sortDataCompany($event)" matSortActive="createdAt" matSortDirection="desc" matSortDisableClear>
        <thead>
          <tr>
            <th style="width: 3%;">#</th>
            <th class="clickable columnTitle" mat-sort-header="category" style="width: 15%;">{{ 'platformNotes.fields.category' | translate }}</th>
            <th class="clickable columnTitle" mat-sort-header="title" style="width: 15%;">{{ 'platformNotes.fields.title' | translate }}</th>
            <th class="clickable columnTitle" mat-sort-header="description" style="width: 15%;">{{ 'platformNotes.fields.description' | translate }}</th>
            <th class="clickable columnTitle" mat-sort-header="createdAt" style="width: 15%;">{{ 'platformNotes.fields.createdAt' | translate }}</th>
            <th class="clickable columnTitle" mat-sort-header="createdBy" style="width: 15%;">{{ 'platformNotes.fields.createdBy' | translate }}</th>
            <th class="clickable columnTitle" mat-sort-header="originalName" style="width: 20%;">{{ 'platformNotes.fields.file' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of sortedDataCompany; let i = index">
            <td style="width: 3%;">{{ i + 1 }}</td>
            <td style="width: 15%;">{{ item.category }}</td>
            <td style="width: 15%;">{{ item.title }}</td>
            <td style="width: 15%;">{{ item.description }}</td>
            <td style="width: 15%;">{{ item.createdAt }}</td>
            <td style="width: 15%;">{{ item.createdBy }}</td>
            <td style="width: 20%;">
              <div *ngIf="item.file && item.file.path">
                <a href="{{ configService.apiHost }}/{{ item.file.path }}" target="_blank" 
                  matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                  {{ item.file.originalName }}
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="sortedDataProperty.length > 0">
      <strong>{{ 'platformNotes.dialog.propertyNotes.property' | translate }}</strong>
      <table class="table table-borderless table-striped" matSort (matSortChange)="sortDataProperty($event)" matSortActive="createdAt" matSortDirection="desc" matSortDisableClear>
        <thead>
          <tr>
            <th style="width: 3%;">#</th>
            <th class="clickable columnTitle" mat-sort-header="property" style="width: 15%;">{{ 'platformNotes.fields.property' | translate }}</th>
            <th class="clickable columnTitle" mat-sort-header="category" style="width: 15%;">{{ 'platformNotes.fields.category' | translate }}</th>
            <th class="clickable columnTitle" mat-sort-header="title" style="width: 15%;">{{ 'platformNotes.fields.title' | translate }}</th>
            <th class="clickable columnTitle" mat-sort-header="description" style="width: 15%;">{{ 'platformNotes.fields.description' | translate }}</th>
            <th class="clickable columnTitle" mat-sort-header="createdAt" style="width: 15%;">{{ 'platformNotes.fields.createdAt' | translate }}</th>
            <th class="clickable columnTitle" mat-sort-header="createdBy" style="width: 15%;">{{ 'platformNotes.fields.createdBy' | translate }}</th>
            <th class="clickable columnTitle" mat-sort-header="originalName" style="width: 20%;">{{ 'platformNotes.fields.file' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of sortedDataProperty; let i = index">
            <td style="width: 3%;">{{ i + 1 }}</td>
            <td style="width: 15%;">{{ item.property }}</td>
            <td style="width: 15%;">{{ item.category }}</td>
            <td style="width: 15%;">{{ item.title }}</td>
            <td style="width: 15%;">{{ item.description }}</td>
            <td style="width: 15%;">{{ item.createdAt }}</td>
            <td style="width: 15%;">{{ item.createdBy }}</td>
            <td style="width: 20%;">
              <div *ngIf="item.file && item.file.path">
                <a href="{{ configService.apiHost }}/{{ item.file.path }}" target="_blank" 
                  matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                  {{ item.file.originalName }}
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
  <ng-container *ngIf="propertyIdBalances !== '' || companyIdBalances !== ''">
    <table class="table table-borderless table-striped" matSort (matSortChange)="sortDataBalance($event)" matSortActive="createdAt" matSortDirection="desc" matSortDisableClear>
      <thead>
        <tr>
          <th style="width: 3%;">#</th>
          <th class="clickable columnTitle" mat-sort-header="balance" style="width: 10%;">{{ 'platformNotes.fields.balance' | translate }}</th>
          <th class="clickable columnTitle" mat-sort-header="category" style="width: 10%;">{{ 'platformNotes.fields.category' | translate }}</th>
          <th class="clickable columnTitle" mat-sort-header="title" style="width: 10%;">{{ 'platformNotes.fields.title' | translate }}</th>
          <th class="clickable columnTitle" mat-sort-header="description" style="width: 15%;">{{ 'platformNotes.fields.description' | translate }}</th>
          <th class="clickable columnTitle" mat-sort-header="createdAt" style="width: 15%;">{{ 'platformNotes.fields.createdAt' | translate }}</th>
          <th class="clickable columnTitle" mat-sort-header="createdBy" style="width: 15%;">{{ 'platformNotes.fields.createdBy' | translate }}</th>
          <th class="clickable columnTitle" mat-sort-header="originalName" style="width: 15%;">{{ 'platformNotes.fields.file' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of sortedDataBalance; let i = index">
          <td style="width: 3%;">{{ i + 1 }}</td>
          <td style="width: 10%;">{{ item.balance }}</td>
          <td style="width: 10%;">{{ item.category }}</td>
          <td style="width: 10%;">{{ item.title }}</td>
          <td style="width: 15%;">{{ item.description }}</td>
          <td style="width: 15%;">{{ item.createdAt }}</td>
          <td style="width: 15%;">{{ item.createdBy }}</td>
          <td style="width: 15%;">
            <div *ngIf="item.file && item.file.path">
              <a href="{{ configService.apiHost }}/{{ item.file.path }}" target="_blank" 
                matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                {{ item.file.originalName }}
              </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-container>

</mat-dialog-content> <!-- mat-dialog-content -->

<div class="row custom-dialog-footer">
  <div class="col-12 col-md-6 text-left">
    <a mat-button (click)="onClose()" mat-raised-button mat-default
      class="ml-3">{{ 'common.cta.close' | translate }}</a>
  </div> <!-- /.col -->
  <div class="col-12 col-md-6 text-right">
    <a mat-button (click)="onPrint()" mat-raised-button mat-default class="ml-3" color="primary">
      {{ 'common.cta.print' | translate }}
      <mat-icon fontSet="fal" fontIcon="fa-print"></mat-icon>
    </a>
  </div> <!-- /.col -->
</div> <!-- /.row -->